import React from 'react'; // 'Suspense' and 'lazy' are removed
import ReactDOM from 'react-dom/client';
import './index.css';
import { HelmetProvider } from 'react-helmet-async';
// AppLoader is no longer needed here
// import AppLoader from './components/AppLoader';

// --- UPDATED: The App component is now imported directly ---
import App from './App';

const rootElement = document.getElementById('root');

// Security & Robustness: Verify the root element exists before rendering.
if (!rootElement) {
  throw new Error("Fatal: The root element with id 'root' was not found in the DOM.");
}

const root = ReactDOM.createRoot(rootElement);

// Development-only error listeners for improved debugging.
if (process.env.NODE_ENV === 'development') {
  window.addEventListener(
    'error',
    e => console.log('[window.onerror]', e.message, 'from', e.filename),
    true
  );
  window.addEventListener(
    'unhandledrejection',
    e => console.log('[unhandledrejection]', e.reason),
    true
  );
}

root.render(
  <React.StrictMode>
    <HelmetProvider>
      {/* --- Suspense wrapper has been removed --- */}
      <App />
    </HelmetProvider>
  </React.StrictMode>
);